import { render, staticRenderFns } from "./LossTablePEM.vue?vue&type=template&id=12b48c5d&scoped=true&"
import script from "./LossTablePEM.vue?vue&type=script&lang=ts&"
export * from "./LossTablePEM.vue?vue&type=script&lang=ts&"
import style0 from "./LossTablePEM.vue?vue&type=style&index=0&id=12b48c5d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b48c5d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/cypher.team.viz/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12b48c5d')) {
      api.createRecord('12b48c5d', component.options)
    } else {
      api.reload('12b48c5d', component.options)
    }
    module.hot.accept("./LossTablePEM.vue?vue&type=template&id=12b48c5d&scoped=true&", function () {
      api.rerender('12b48c5d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/LossTablePEM.vue"
export default component.exports